import React from "react";
import { useTheme } from "styled-components";
import HeadingAndLinks from "./headingAndLinks";
import { footerOtherLinks } from "helpers/links-builders/footerLinks";
import useGetCountry from "../../../../hooks/useGetCountry";

export default function Others() {
  const { translations, locale, country } = useTheme();
  const fullCountryName = useGetCountry()
  const links = footerOtherLinks(translations, locale, country ,fullCountryName);

  return (
    <HeadingAndLinks
      parentComponent={"Others"}
      isMultiCol={false}
      headerText={translations.footer.otherTab}
      LinksData={links}
    />
  );
}
